var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      class: [_vm.bemBlock, "price"],
      attrs: {
        itemprop: "offers",
        itemscope: "",
        itemtype: "http://schema.org/Offer"
      }
    },
    [
      _c("meta", {
        attrs: { itemprop: "priceCurrency", content: _vm.price.currency }
      }),
      _vm._v(" "),
      _vm.title
        ? _c("span", { class: _vm.bemElement("title") }, [
            _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.originalPrice && _vm.originalPrice.text !== null && _vm.isTotalPrice
        ? _c("p", { class: _vm.bemElement("promo-text") }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$msg("line-item-total-price.promo-text", "cart")) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.hideDiscount && _vm.originalPrice && _vm.originalPrice.text !== null
        ? _c("span", { class: _vm.bemElement("original-price") }, [
            _vm._v("\n    " + _vm._s(_vm.originalPrice.text) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          class: _vm.bemElement("price"),
          attrs: { content: _vm.price.value, itemprop: "price" }
        },
        [_vm._v("\n    " + _vm._s(_vm.price.text) + "\n  ")]
      ),
      _vm._v(" "),
      !_vm.hideDiscount && _vm.hasDiscount()
        ? _c("span", { class: _vm.bemElement("discount") }, [
            _vm._v("\n    " + _vm._s(_vm.formattedDiscountPercent) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showPreviousPriceMsg && _vm.additionalInfoPrice.text
        ? _c("BaseInfoMsg", {
            class: _vm.bemElement("msg"),
            attrs: {
              text: _vm.additionalInfoPrice.text,
              "text-tooltip": _vm.showPreviousPriceMsgTooltip
                ? _vm.additionalInfoPrice.tooltip
                : null
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }